import { Stack } from "@vapor/react-material";
import dayjs from "dayjs";
import type { ReactElement } from "react";
import { useMemo } from "react";

import { useGetExpiringIdentities } from "../../../../../core/api/use-get-expiring-identities/useGetExpiringIdentities";
import { ExpiringIdentityNotification } from "./ExpiringIdentityNotification";

export const ExpiringIdentitiesWarnings = (): ReactElement | null => {
    const { data: expiringIdentities } = useGetExpiringIdentities();

    const partitioned = useMemo(() => {
        if (!expiringIdentities) return null;
        const now = dayjs();
        const allSubjects = [
            ...expiringIdentities.intermediaries,
            ...expiringIdentities.delegates,
        ];
        const isExpired = (s: { expirationDate: Date }) =>
            dayjs(s.expirationDate).isBefore(now, "day");
        return {
            expiredCredentials: allSubjects.filter(isExpired),
            expiringCredentials: allSubjects.filter((s) => !isExpired(s)),
            expiredSecurityEnvironments:
                expiringIdentities.securityEnvironments.filter(isExpired),
            expiringSecurityEnvironments:
                expiringIdentities.securityEnvironments.filter(
                    (s) => !isExpired(s),
                ),
        };
    }, [expiringIdentities]);

    if (!partitioned) return null;

    return (
        <Stack gap={1}>
            <ExpiringIdentityNotification
                variant="expiredCredentials"
                identities={partitioned.expiredCredentials}
            />
            <ExpiringIdentityNotification
                variant="expiredSecurityEnvironments"
                identities={partitioned.expiredSecurityEnvironments}
            />
            <ExpiringIdentityNotification
                variant="expiringCredentials"
                identities={partitioned.expiringCredentials}
            />
            <ExpiringIdentityNotification
                variant="expiringSecurityEnvironments"
                identities={partitioned.expiringSecurityEnvironments}
            />
        </Stack>
    );
};
